// extracted by mini-css-extract-plugin
export var dividerContainer = "_9j-0";
export var line = "_9j-1";